import { ChevronRight, SettingsRounded, InfoRounded } from '@mui/icons-material'
import classNames from 'classnames'
import { appealStatus } from 'feature/appeals/helpers/appealStatus'
import { getRightsForOrderManage } from 'feature/appeals/helpers/getRightsForOrderManage'
import { useOfferPriceBlock } from 'feature/appeals/components/AppealOffer/OfferPriceBlock/useOfferPriceBlock'
import { stateCurrentAppeal } from 'feature/appeals/redux/appealFormCreateSelector'
import { TAppeal } from 'feature/appeals/type'
import { formatPhoneNumber } from 'helpers/phones'
import { removeModalScrollSafari } from 'helpers/removeModalScrollSafari'
import { useState } from 'react'
import { useActions, useAppSelector } from 'store/hooks'
import { Button, Chip } from 'ui'
import { LoaderInCentalPosition } from 'widget'

import { ModalDealerInformation } from '../ModalDealerInformation/ModalDealerInformation'
import { ModalOrderManage } from '../ModalOrderManage/ModalOrderManage'
import { ModalWrap } from '../ModalWrap/ModalWrap'

import style from './AppealHeader.module.scss'

type TAppealHeader = {
  data: TAppeal
}

// шапка заявки
export function AppealHeader({ data }: TAppealHeader) {
  const [isManageModalOpen, setManageModalOpen] = useState<boolean>(false)
  const [isDealerModalOpen, setDealerModalOpen] = useState<boolean>(false)
  const { appealType, editAppealLoading } = useAppSelector(stateCurrentAppeal)
  const { setIsPullingStopped } = useActions()

  const { status, name, dealer, user, dealerCode, number, hasPayment, offers } =
    data
  const handleCloseManageModal = () => {
    removeModalScrollSafari(false)
    setManageModalOpen(false)
    setIsPullingStopped(false)
  }

  const handleCloseDealerModal = () => {
    setDealerModalOpen(false)
    removeModalScrollSafari(false)
    setIsPullingStopped(false)
  }
  const handleOpenManageModal = () => {
    removeModalScrollSafari(true)
    setManageModalOpen(true)
    setIsPullingStopped(true)
  }

  const handleOpenDealerModal = () => {
    removeModalScrollSafari(true)
    setDealerModalOpen(true)
    setIsPullingStopped(true)
  }

  const isAppealManagerLoading = editAppealLoading.appealManager
  const hasPaidOrder = offers.some(order => order.offer?.payDate !== null)

  const approvedOffer = offers.find(o => o.status === 'APPROVED')?.offer
  const { stageStatusName } = useOfferPriceBlock(approvedOffer, status.status)

  const baseStatusName =
    status.name.charAt(0).toUpperCase() + status.name.slice(1)
  const statusName = stageStatusName ?? baseStatusName

  return (
    <div className=''>
      <Button
        // @ts-ignore
        to='/appeals'
        variant='text'
        className={style.backButton}
        color='primary'
        data-testid='appeal-back-btn'
        startIcon={
          <ChevronRight
            color='primary'
            className={classNames('rotate180', style.chevronRight)}
          />
        }
      >
        Назад
      </Button>

      <div className={style.header}>
        <div className={style.headerLeft}>
          <div className={classNames(style.appealName, 'h1')}>{name}</div>
          <div className={style.appealInf}>
            <div className={style.appealInfItem}>
              <span className='caption'>Номер заказа</span>
              <span className='caption'>{number}</span>
            </div>
            {user.additionalPhone && (
              <div className={style.appealInfItem}>
                <span className='caption'>Телефон получателя</span>
                <span className='caption'>
                  {formatPhoneNumber(user.additionalPhone)}
                </span>
              </div>
            )}

            {dealerCode && (
              <div className={style.appealInfItem}>
                <span className='caption'>Код дилера</span>
                <span className='caption'>{dealerCode}</span>
              </div>
            )}
          </div>
          <div className={style.status}>
            <Chip status={appealStatus(status.status)} label={statusName} />
          </div>
        </div>
        <div className={style.headerRight}>
          {!dealer || dealer.isTechnicalDepartment ? (
            <span className={style.dillerStatus}>
              По заказу будет назначен дилер, с Вами свяжутся в ближайшее время
            </span>
          ) : (
            <div className={style.diller}>
              <span className={style.dillerStatus}>Ваш дилер</span>
              <div
                className={style.dillerInf}
                onClick={handleOpenDealerModal}
                data-testid='appeal-dealer-info'
              >
                <span>{dealer.name}</span>
                <InfoRounded color='primary' />
              </div>
            </div>
          )}

          {getRightsForOrderManage('manage', status.status) &&
            appealType === 'order' && (
              <div className={style.manageBlock}>
                {isAppealManagerLoading && <LoaderInCentalPosition />}
                {!isAppealManagerLoading && (
                  <Button
                    variant='contained'
                    color='secondary'
                    className={style.manageButton}
                    onClick={handleOpenManageModal}
                    data-testid='appeal-manage-btn'
                    startIcon={
                      <SettingsRounded
                        color='primary'
                        className={classNames(
                          'rotate180',
                          style.SettingsRounded,
                        )}
                      />
                    }
                  >
                    Управление
                    {hasPayment ? ' заказом' : ' заявкой'}
                  </Button>
                )}
              </div>
            )}
        </div>

        <ModalWrap
          isModalOpen={isManageModalOpen}
          onClose={handleCloseManageModal}
        >
          <ModalOrderManage
            onClose={handleCloseManageModal}
            orderStatus={status.status}
            hasPaidOrder={hasPaidOrder}
          />
        </ModalWrap>

        {dealer && (
          <ModalWrap
            isModalOpen={isDealerModalOpen}
            onClose={handleCloseDealerModal}
            tabletSmallSize
          >
            <ModalDealerInformation
              onClose={handleCloseDealerModal}
              dealer={dealer}
            />
          </ModalWrap>
        )}
      </div>
    </div>
  )
}
